// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Dropdown from "../../components/html/Dropdown.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../models/Kkm.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmCreatePage$OfdSelect(Props) {
  let ofd = Props.ofd;
  let onOfdSelect = Props.onOfdSelect;
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const appMode = cfg.app_mode;
  const match = React.useState(function () {
    return false;
  });
  const setIsDropdownShown = match[1];
  const isDropdownShown = match[0];
  const activator = function (param) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: Buhta_cabinet__Kkm.Provider.toString(ofd)
        }),
        JsxRuntime.jsx("img", {
          className: "w-6 h-6",
          src: StaticAsset.src("/static/icons/select-arrows.svg")
        }),
        JsxRuntime.jsx("p", {
          children: "Оператор ОФД",
          className: Cn.$plus(Cn.$plus("absolute bg-white transition-all text-gray-medium", Cn.on("-top-2.5 left-2 px-2 text-xs", ofd !== 0 || isDropdownShown)), Cn.on("text-sm top-3 left-4 px-0", ofd === 0 && !isDropdownShown))
        })
      ],
      className: "rounded-sm border border-gray-main px-4 py-[9px] mt-4 flex justify-between relative items-center"
    });
  };
  const __x = appMode === "live" ? ({
      hd: 2,
      tl: {
        hd: 3,
        tl: /* [] */ 0
      }
    }) : ({
      hd: 1,
      tl: {
        hd: 2,
        tl: {
          hd: 3,
          tl: /* [] */ 0
        }
      }
    });
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
    align: "BottomCenter",
    activator: activator,
    background: "bg-white",
    isDropdownShown: isDropdownShown,
    setIsDropdownShown: setIsDropdownShown,
    children: JsxRuntime.jsx("div", {
      children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, o) {
        const Key = "dt-" + String(index);
        return JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-black",
            children: Buhta_cabinet__Kkm.Provider.toString(o)
          }),
          className: Cn.$plus("flex items-center space-x-2 px-4 py-1.5", "cursor-pointer  hover:bg-gray-light"),
          onClick: (function (param) {
            Curry._1(onOfdSelect, o);
            Curry._1(setIsDropdownShown, (function (param) {
              return false;
            }));
          })
        }, Key);
      }))),
      className: "py-2 flex flex-col"
    })
  });
}

const OfdSelect = {
  make: KkmCreatePage$OfdSelect
};

function KkmCreatePage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const currentUrl = Buhta_cabinet__Route.useUrl(undefined);
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const appMode = cfg.app_mode;
  const returnUrl = Belt__Belt_Option.getWithDefault(Buhta_cabinet__Route.getParamValue(currentUrl, "return_to", undefined), "/org/" + (String(org.id) + "/kassa/kkms"));
  const match$2 = React.useState(function () {
    return "";
  });
  const setName = match$2[1];
  const name = match$2[0];
  const match$3 = React.useState(function () {
    if (appMode === "live") {
      return 0;
    } else {
      return 1;
    }
  });
  const setOfd = match$3[1];
  const ofd = match$3[0];
  const match$4 = React.useState(function () {
    return "Бухта 1.0";
  });
  const setModel = match$4[1];
  const closeButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.getRouterUrl(returnUrl)),
    children: JsxRuntime.jsx("img", {
      src: StaticAsset.src("/static/icons/close-20.svg")
    })
  });
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Касса",
      leftChildren: closeButton,
      openMenu: openMenu
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Новая касса",
      route: contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: /* List */ 1
        }
      })
    });
  const initialFocusRef = React.useRef(null);
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                onSubmit: (function (param) {
                  const newKkm = {
                    ofd_provider_id: ofd,
                    name: name
                  };
                  const __x = Buhta_cabinet__Kassa.KkmManagerService.create(tenant, newKkm);
                  $$Promise.get(__x, (function (result) {
                    if (result.TAG !== /* Ok */ 0) {
                      return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
                    }
                    const data = result._0;
                    Buhta_cabinet__Route.navigateTo(contextRoute(data.ofd_provider_id === 1 ? ({
                        TAG: /* Kassa */ 2,
                        _0: {
                          TAG: /* Kkms */ 0,
                          _0: {
                            TAG: /* Kkm */ 0,
                            _0: data.id,
                            _1: /* Register */ 1
                          }
                        }
                      }) : ({
                        TAG: /* Kassa */ 2,
                        _0: {
                          TAG: /* Kkms */ 0,
                          _0: {
                            TAG: /* Kkm */ 0,
                            _0: data.id,
                            _1: /* Start */ 0
                          }
                        }
                      })));
                    Curry._1(dispatchToasts, {
                      TAG: /* Add */ 0,
                      _0: {
                        id: Buhta_core__Toast.generateId(undefined),
                        text: "ККМ успешно создана",
                        kind: "success",
                        onClick: (function (param) {
                          
                        })
                      }
                    });
                  }));
                }),
                initialFocusRef: initialFocusRef,
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                    label: "Название",
                    type_: "text",
                    name: "name",
                    size: "m",
                    required: true,
                    onChange: (function (value) {
                      Curry._1(setName, (function (param) {
                        return value;
                      }));
                    }),
                    inputRef: initialFocusRef,
                    value: name
                  }),
                  JsxRuntime.jsx(KkmCreatePage$OfdSelect, {
                    ofd: ofd,
                    onOfdSelect: (function (o) {
                      Curry._1(setOfd, (function (param) {
                        return o;
                      }));
                    })
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KkmModelSelect.make, {
                      model: match$4[0],
                      onModelSelect: (function (value) {
                        Curry._1(setModel, (function (param) {
                          return value;
                        }));
                      })
                    }),
                    className: "mt-5"
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                    title: "Создать",
                    className: "py-3 mt-6 w-full",
                    type_: "submit"
                  })
                ]
              }),
              JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                className: "mt-4 text-asphalt",
                children: [
                  "Нажимая \"Создать\", вы принимаете пользовательское соглашение по использованию ",
                  JsxRuntime.jsx("a", {
                    children: "АПК \"Бухта 1.0\"",
                    className: "text-black",
                    href: "https://buhta.com/kz/ru/legal/agreement",
                    target: "_blank"
                  }),
                  " и ",
                  JsxRuntime.jsx("a", {
                    children: "ОФД Бухта",
                    className: "text-black",
                    href: "https://buhta.com/kz/ru/legal/agreement",
                    target: "_blank"
                  })
                ]
              })
            ],
            className: "p-10"
          }),
          className: "bg-white lg:w-[562px] border border-gray-main rounded-md shadow-kkms"
        }),
        className: "py-6 lg:py-10 px-4 lg:px-0"
      }),
      className: "w-full flex flex-col items-center"
    }),
    className: "bg-gray-pale"
  });
}

const make = KkmCreatePage;

export {
  OfdSelect,
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
